<template>
  <v-card elevation="0" class="px-4">
    <v-divider></v-divider>
    <div class="d-flex align-strech pt-3 pb-7 mt-2">
      <v-text-field
        style="flex: 0 1 300px"
        v-model="search"
        append-icon="mdi-magnify"
        outlined
        :label="this.$t('sales.clientsList.search')"
        single-line
        dense
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog persistent v-model="formDialog" class="" width="700">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            dark
            v-bind="attrs"
            v-on="on"
            color="success"
            height="40"
            elevation="0"
            class="ml-2"
            >{{ $t("common.add") }}</v-btn
          >
        </template>
        <v-card class="mx-auto">
          <v-card-title class="text-h5 mb-2">
            {{ $t("sales.commercialPolicies.add.form.title") }}
          </v-card-title>
          <v-card-text>
            <form>
              <v-text-field
                v-model="form.code"
                :label="this.$t('sales.commercialPolicies.add.form.role')"
              ></v-text-field>
              <!-- <v-text-field
                v-model="form.minPrice"
                :label="$t('sales.commercialPolicies.add.form.minPrice')"
                @input="v$.form.minPrice.$touch()"
                @blur="v$.form.minPrice.$touch()"
                :error-messages="isEqualError"
              >
              </v-text-field> -->
              <VuetifyMoney
                :disabled="editBtn"
                :label="$t('sales.commercialPolicies.add.form.minPrice')"
                @input="v$.form.minPrice.$touch()"
                @blur="v$.form.minPrice.$touch()"
                :errorMessages="isEqualError"
                v-model="form.minPrice"
                v-bind:options="optionsVmoney"
              />

              <!-- <v-text-field  type="number" v-model="form.maxPrice" :label="this.$t('sales.commercialPolicies.add.form.maxPrice')"></v-text-field> -->
              <!-- <v-radio-group mandatory :label="this.$t('sales.commercialPolicies.add.form.discountType')" v-model="form.discountType">
                <div class="d-flex align-center">
                  <v-radio
                    :label="$t('sales.commercialPolicies.add.form.fixedDiscount')"
                    value="fixed"
                  ></v-radio>
                </div>
                <div class="d-flex align-center">
                  <v-radio
                    :label="$t('sales.commercialPolicies.add.form.percentDiscount')"
                    value="percent"
                  ></v-radio>
                </div>
              </v-radio-group> -->
              <v-text-field
                :disabled="editBtn"
                suffix="%"
                type="number"
                :error-messages="isRangeError"
                v-model="form.discountValue"
                :label="
                  this.$t('sales.commercialPolicies.add.form.discountValue')
                "
              ></v-text-field>
              <v-radio-group
                :label="this.$t('sales.commercialPolicies.add.form.status')"
                mandatory
                v-model="form.status"
              >
                <div class="d-flex align-center">
                  <v-radio :label="$t('common.active')" :value="true"></v-radio>
                </div>
                <div class="d-flex align-center">
                  <v-radio
                    :label="$t('common.inactive')"
                    :value="false"
                  ></v-radio>
                </div>
              </v-radio-group>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="form.duedate"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formatDuedate"
                    :label="
                      $t('sales.commercialPolicies.add.form.policyValidity')
                    "
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="form.duedate" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(form.duedate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
              <div class="d-flex">
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="
                    (formDialog = false),
                      (editBtn = false),
                      (currentPolicyId = '')
                  "
                  class="mr-1"
                  >{{ $t("common.cancel") }}</v-btn
                >
                <v-btn
                  v-if="editBtn == false"
                  @click="saveNewPolicies(currentPolicyId)"
                  color="success"
                  elevation="0"
                >
                  {{ $t("common.save") }}
                </v-btn>
                <v-btn
                  v-else
                  @click="saveNewPolicies(currentPolicyId)"
                  color="success"
                  elevation="0"
                >
                  {{ $t("common.editBtn") }}
                </v-btn>
              </div>
              <div class="d-flex justify-end"></div>
            </form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-card outlined>
      <v-data-table
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-options': [10, 25, 50],
        }"
        :headers="headers"
        :items="policiesItems"
        :items-per-page="10"
        class="elevation-1"
      >
        <template v-slot:[`item.minPrice`]="{ item }">
          {{ $n(item.minPrice, "currency") }}
        </template>
        <template v-slot:[`item.discountValue`]="{ item }">
          {{ `${item.discountValue}%` }}
        </template>
        <template v-slot:[`item.duedate`]="{ item }">
          {{ item.duedate | date }}
        </template>
        <template v-slot:[`item.createdOn`]="{ item }">
          {{ item.createdOn | dateTime }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <!-- <template v-if="item.verified">
                        <span class="hide-text">{{ item.verified }}</span>
                        {{ item.verified | dateTime }}
                    </template> -->
          <template v-if="item.status">
            <v-chip label color="green" class="white--text mx-4" small>{{
              $t("common.active")
            }}</v-chip>
          </template>
          <v-chip v-else label color="error lighten-2 " class="mx-4" small>{{
            $t("common.inactive")
          }}</v-chip>
        </template>
        <template v-slot:[`item.btn`]="{ item }">
          <div>
            <v-btn class="ml-8" icon small @click="editPolicy(item)"
              ><v-icon>mdi-pencil-outline</v-icon></v-btn
            >
            <v-btn class="ml-8" icon small @click="openConfirmDialog(item)"
              ><v-icon color="red">mdi-trash-can-outline</v-icon></v-btn
            >
          </div>
        </template>
      </v-data-table>
      <div class="text-center">
        <v-dialog persistent v-model="confirmDialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              {{ this.$t("common.deleteUser") }}
            </v-card-title>
            <div class="px-4">
              <v-text-field
                v-model="deleteDialogText"
                :placeholder="
                  $t(
                    'account.whitelabel.data.usersManagement.form.confirmDelete'
                  )
                "
              >
              </v-text-field>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="d-flex justify-end">
                  <v-btn
                  text
                  @click="
                    (confirmDialog = false),
                      (currentPolicyId = '')
                  "
                  class="mr-1"
                  >{{ $t("common.cancel") }}</v-btn
                >
                <v-btn 
                  :disabled="
                    deleteDialogText !== 'DELETAR' &&
                    deleteDialogText !== 'DELETE' &&
                    deleteDialogText !== 'ELIMINAR'
                  "
                  color="red"
                  class="white--text"
                  @click="deletePolicy()"
                >
                  {{ $t("common.remove") }}
                </v-btn>
                
              </div>
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>
      </div>
    </v-card>
  </v-card>
</template>

<script>
import VuetifyMoney from "@/components/VuetifyMoney";
import useVuelidate from "@vuelidate/core";
import { required, numeric, minLength, maxLength } from "@vuelidate/validators";
import validations from "@/plugins/validations";
import config from "@/store/config";
import { initializeApp } from "firebase/app";
import { mapActions } from "vuex";
import {
  getFirestore,
  collection,
  query,
  deleteDoc,
  setDoc,
  doc,
  getDocs,
  writeBatch,
} from "firebase/firestore";
import moment from "moment";
const isEqual = (field, value, compare) =>
  validations.isEqual(field, value, compare);

export default {
  components: {
    VuetifyMoney,
  },
  name: "CommercialPolicies",

  setup() {
    return { v$: useVuelidate() };
  },

  validations() {
    return !this.currentPolicyId
      ? {
          form: {
            minPrice: {
              isEqual: () => !this.isEqualComp,
              invalidRange: () => this.RangePoliciesRules,
            },
          },
        }
      : {};
  },

  data() {
    return {
      currentPolicyId: null,
      deleteDialogText: "",
      confirmDialog: false,
      editBtn: false,
      policiesRules: {},
      menu: false,
      loading: false,
      formDialog: false,
      search: "",
      form: {
        id: "",
        code: "",
        minPrice: null,
        maxPrice: null,
        discountType: "percent",
        discountValue: null,
        status: null,
        duedate: moment().add(6, "months").format("YYYY-MM-DD"),
        createdOn: null,
      },

      policiesItems: [],
    };
  },
  computed: {
    optionsVmoney() {
      return {
        locale: this.$root.lang,
        prefix: this.$root.auth.whitelabel.country == "Brasil" ? "R$" : "S/",
        suffix: "",
        length: 9,
        precision: 2,
      };
    },

    formatDuedate() {
      return moment(this.form.duedate).format("L");
    },

    isEqualComp() {
      return this.policiesItems
        ? isEqual("minPrice", this.policiesItems, this.form.minPrice)
        : false;
    },
    isEqualError() {
      const errors = [];
      if (!this.v$.form?.minPrice.$dirty || this.currentPolicyId) return errors;
      this.v$.form.minPrice.isEqual.$invalid &&
        errors.push(
          this.$t("sales.commercialPolicies.add.form.errors.isEqual")
        );
      return errors;
    },
    isRangeError() {
      const errors = [];
      if (!this.v$.form?.minPrice.$dirty || this.currentPolicyId) return errors;
      this.v$.form.minPrice.invalidRange.$invalid &&
        errors.push(
          this.$t("sales.commercialPolicies.add.form.errors.invalidRange")
        );
      return errors;
    },

    headers() {
      return [
        {
          text: this.$t("sales.commercialPolicies.add.form.code"),
          align: "start",
          sortable: true,
          value: "code",
        },
        {
          text: this.$t("sales.commercialPolicies.add.form.minPrice"),
          align: "center",
          sortable: true,
          value: "minPrice",
        },

        {
          text: this.$t("sales.commercialPolicies.add.form.discountValue"),
          align: "center",
          sortable: true,
          value: "discountValue",
        },
        {
          text: this.$t("sales.commercialPolicies.add.form.status"),
          align: "center",
          sortable: true,
          value: "status",
        },
        {
          text: this.$t("sales.commercialPolicies.add.form.dueDate"),
          align: "start",
          sortable: true,
          value: "duedate",
        },
        {
          text: this.$t("sales.commercialPolicies.add.form.createdOn"),
          align: "start",
          sortable: true,
          value: "createdOn",
        },
        {
          text: "",
          align: "start",
          sortable: true,
          value: "btn",
        },
      ];
    },

    lowestValue() {
      const lowest = Math.min(
        ...this.policiesItems.map((item) => item.minPrice)
      );
      return lowest;
    },
    highestValue() {
      const highest = Math.max(
        ...this.policiesItems.map((item) => item.minPrice)
      );
      return highest;
    },
    RangePoliciesRules() {
      if (
        !this.form.discountValue ||
        !this.policiesItems ||
        !this.policiesItems.length
      ) {
        return true;
      }

      const result = { min: null, max: null }; // result é o objet esqueleto criado para min e  max price da tabela
      const keys = {}; // As chaves que vamos usar para achar os itens do objeto esqueleto
      const discountValue = this.form.discountValue; //valor do desconto digitado

      this.policiesItems.forEach((item) => {
        //Pega a tabela de politicas e pra cada uma
        const key = this.$n(item.minPrice); // const key é igual ao volume mínimo de cada item
        console.log("key", key);
        keys[key] = parseFloat(item.discountValue); // cada propriedade do objeto keys agora é um volume mínimo da tabela e seu valor é seu desconto

        if (parseFloat(item.minPrice) < parseFloat(this.form.minPrice)) {
          //se o item iterado for menor que o item digitado no form
          console.log(
            `o item ${item.minPrice} é menor que ${this.form.minPrice} que vc digitou`
          );
          if (!result.min) {
            console.log("não tem result.min");
            // e se result ainda não foi preenchido
            result.min = this.$n(item.minPrice); // o result.min será igual a  estes valores da tabela menores que o form
          } else {
            // se não
            if (result.min < item.minPrice) {
              // se result.min tiver algo e for menor que os itens iterados da tabela
              result.min = this.$n(item.minPrice); // result.min será igual os itens da tabela menores que o form
            }
          }
        }

        if (parseFloat(item.minPrice) > parseFloat(this.form.minPrice)) {
          // se o item iterado da tabela for maior que o volume minimo digitado no form
          console.log("Este item é maior que o digitado");
          if (!result.max) {
            // e se o result.max nao existir
            console.log("não tem result.max");
            result.max = this.$n(item.minPrice); // o result.max será igual a  estes valores da tabela maiores que o form
          } // se não
          if (result.max > item.minPrice) {
            // se não, se result.max  tiver algo e for maior que os itens iterados da tabela
            result.max = this.$n(item.minPrice); //  result.max é igual a todos os itens da tabela maiores que o form
          }
        }
      });

      console.log("result", result);
      console.log("keys", keys);

      if (result.min)
        // se o result.min existir
        console.log("result.min", keys[result.min]);
      if (this.$n(discountValue) <= keys[result.min]) return false;
      // se o disconto digitado for menor ou igual as keys(pega a key que tem volume mínimo e compara seu desconto) retorna o erro

      if (result.max)
        if (this.$n(discountValue) >= keys[result.max]) return false;
      // se o disconto digitado for MAIOR ou igual as keys(pega a key que tem volume MÁXIMO e compara seu desconto) retorna o erro

      //   if (result.min && this.$n(discountValue) <= keys[this.$n(result.min)])
      //     return false;
      //   if (result.max && this.$n(discountValue) <= keys[this.$n(result.max)])
      //     return false;

      return true; // caso não, sem erro
    },

    defaultPoliciesName() {
      const itemsLength = this.policiesItems.length + 1;
      return `${this.$t(
        "sales.commercialPolicies.add.form.defaultPoliciesName"
      )} ${itemsLength}`;
    },
  },

  mounted() {
    this.loadDocuments();
  },

  methods: {
    ...mapActions("snackbar", ["showSnack"]),

    openConfirmDialog(item) {
      this.currentPolicyId = item.id;
      this.confirmDialog = true;
    },

    deletePolicy() {
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      deleteDoc(doc(db, "commercialPolicies", this.currentPolicyId))
        .then((res) => {
          this.loadDocuments();
        })
        .then(() => {
          this.confirmDialog = false;
          this.showSnack({
            text: this.$t(
              "sales.commercialPolicies.add.form.snackMessages.policiesRemoved"
            ),
            color: "success",
            timeout: 2800,
            icon: "mdi-check",
          });
        });
    },

    editPolicy(item) {
      this.currentPolicyId = item.id;
      this.formDialog = true;
      console.log("snap to edit", item);
      this.form = JSON.parse(JSON.stringify(item));
      this.editBtn = true;
    },

    loadDocuments() {
      this.loading = true;
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const q = query(collection(db, "commercialPolicies"));
      const querySnapshot = getDocs(q);
      const documents = [];
      querySnapshot
        .then((docs) => {
          docs.forEach((doc) => {
            // doc.
            const computed = {
              createdOn: moment(doc.data().createdOn).format(
                "DD/MM/YYYY HH:mm:ss"
              ),
            };
            documents.push({ ...doc.data(), id: doc.id, computed: computed });
          });
          this.policiesItems = documents;
          this.loading = false;
        })
        .then(() => {
          (this.form = {
            id: "",
            code: "",
            minPrice: null,
            maxPrice: null,
            discountType: "percent",
            discountValue: null,
            status: null,
            duedate: moment().add(6, "months").format("YYYY-MM-DD"),
            createdOn: null,
          }),
            (this.form.code = this.defaultPoliciesName);
        });
    },

    objectId() {
      var timestamp = ((new Date().getTime() / 1000) | 0).toString(16);
      return (
        timestamp +
        "xxxxxxxxxxxxxxxx"
          .replace(/[x]/g, () => {
            return ((Math.random() * 16) | 0).toString(16);
          })
          .toLowerCase()
      );
    },

    saveNewPolicies(policyId) {
      if (!policyId) {
        this.v$.$touch();
        if (!this.v$.$invalid) {
          if (this.$vnode.t) this.loading = true;
          const firebase = initializeApp(config);
          const db = getFirestore(firebase);
          const Form = JSON.parse(JSON.stringify(this.form));
          console.log("Form", Form);
          Form.createdOn = moment().format();
          const id = this.objectId();
          Form.id = id;
          setDoc(doc(db, "commercialPolicies", id), Form)
            .then(() => {
              this.loading = false;

              // this.form = JSON.parse(JSON.stringify(this.snap))
              this.loadDocuments();
            })
            .then(() => {
              this.formDialog = false;
              this.showSnack({
                text: this.$t(
                  "sales.commercialPolicies.add.form.snackMessages.policiesAdded"
                ),
                color: "success",
                timeout: 2800,
                icon: "mdi-check",
              });
            });
        }
      } else {
        this.v$.$touch();
        if (!this.v$.$invalid) {
          if (this.$vnode.t) this.loading = true;
          const firebase = initializeApp(config);
          const db = getFirestore(firebase);
          const Form = JSON.parse(JSON.stringify(this.form));
          console.log("Form", Form);
          Form.createdOn = moment().format();
          const id = policyId;
          Form.id = id;
          setDoc(doc(db, "commercialPolicies", id), Form)
            .then(() => {
              this.loading = false;

              // this.form = JSON.parse(JSON.stringify(this.snap))
              this.loadDocuments();
            })
            .then(() => {
              this.formDialog = false;
              this.editBtn = false;
              this.showSnack({
                text: this.$t(
                  "sales.commercialPolicies.add.form.snackMessages.policiesEdited"
                ),
                color: "success",
                timeout: 2800,
                icon: "mdi-check",
              });
            });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
